/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ invitedBy: NonNullable<unknown>, org: NonNullable<unknown> }} Email_Invite_SubjectInputs */

const th_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} เชิญคุณเข้าร่วม ${i?.org} บน Remy Sport`)
};

const en_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} invited you to join ${i?.org} on Remy Sport`)
};

const ja_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy}さんから Remy Sport の${i?.org}への招待が届いています`)
};

const zh_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} 邀请你加入 Remy Sport 上的 ${i?.org}`)
};

const es_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} te invitó a unirte a ${i?.org} en Remy Sport`)
};

const pt_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} convidou você para entrar em ${i?.org} no Remy Sport`)
};

const id_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} mengundang Anda ke ${i?.org} di Remy Sport`)
};

const fr_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} vous a invité à rejoindre ${i?.org} sur Remy Sport`)
};

const tl_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inanyayahan ka ni ${i?.invitedBy} sa ${i?.org} sa Remy Sport`)
};

const vi_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} đã mời bạn vào ${i?.org} trên Remy Sport`)
};

const ko_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy}님이 Remy Sport의 ${i?.org}에 초대했습니다`)
};

const de_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} hat dich zu ${i?.org} auf Remy Sport eingeladen`)
};

const ru_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} пригласил(а) вас в ${i?.org} на Remy Sport`)
};

const tr_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} sizi Remy Sport'ta ${i?.org} kuruluşuna davet etti`)
};

const it_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} ti ha invitato a ${i?.org} su Remy Sport`)
};

const pl_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} zaprasza cię do ${i?.org} w Remy Sport`)
};

const uk_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} запросив(ла) вас до ${i?.org} на Remy Sport`)
};

const hi_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} ने आपको Remy Sport पर ${i?.org} में आमंत्रित किया है`)
};

const ar_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`دعاك ${i?.invitedBy} إلى ${i?.org} على Remy Sport`)
};

const ms_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} menjemput anda ke ${i?.org} di Remy Sport`)
};

const bn_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} আপনাকে Remy Sport-এ ${i?.org}-এ আমন্ত্রণ জানিয়েছেন`)
};

const zh_tw2_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} 邀請你加入 Remy Sport 上的 ${i?.org}`)
};

const zh_hk2_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} 邀請你加入 Remy Sport 上的 ${i?.org}`)
};

const ur_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} نے آپ کو Remy Sport پر ${i?.org} میں مدعو کیا ہے`)
};

const fa_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} شما را به ${i?.org} در Remy Sport دعوت کرد`)
};

const sw_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} amekualika kwenye ${i?.org} katika Remy Sport`)
};

const nl_email_invite_subject = /** @type {(inputs: Email_Invite_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.invitedBy} heeft je uitgenodigd voor ${i?.org} op Remy Sport`)
};

/**
* | output |
* | --- |
* | "{invitedBy} invited you to join {org} on Remy Sport" |
*
* @param {Email_Invite_SubjectInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_invite_subject = /** @type {((inputs: Email_Invite_SubjectInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Invite_SubjectInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_invite_subject(inputs)
	if (locale === "ja") return ja_email_invite_subject(inputs)
	if (locale === "zh") return zh_email_invite_subject(inputs)
	if (locale === "es") return es_email_invite_subject(inputs)
	if (locale === "pt") return pt_email_invite_subject(inputs)
	if (locale === "id") return id_email_invite_subject(inputs)
	if (locale === "fr") return fr_email_invite_subject(inputs)
	if (locale === "tl") return tl_email_invite_subject(inputs)
	if (locale === "vi") return vi_email_invite_subject(inputs)
	if (locale === "ko") return ko_email_invite_subject(inputs)
	if (locale === "de") return de_email_invite_subject(inputs)
	if (locale === "ru") return ru_email_invite_subject(inputs)
	if (locale === "tr") return tr_email_invite_subject(inputs)
	if (locale === "it") return it_email_invite_subject(inputs)
	if (locale === "pl") return pl_email_invite_subject(inputs)
	if (locale === "uk") return uk_email_invite_subject(inputs)
	if (locale === "hi") return hi_email_invite_subject(inputs)
	if (locale === "ar") return ar_email_invite_subject(inputs)
	if (locale === "ms") return ms_email_invite_subject(inputs)
	if (locale === "bn") return bn_email_invite_subject(inputs)
	if (locale === "zh-TW") return zh_tw2_email_invite_subject(inputs)
	if (locale === "zh-HK") return zh_hk2_email_invite_subject(inputs)
	if (locale === "ur") return ur_email_invite_subject(inputs)
	if (locale === "fa") return fa_email_invite_subject(inputs)
	if (locale === "sw") return sw_email_invite_subject(inputs)
	if (locale === "nl") return nl_email_invite_subject(inputs)
	return en_email_invite_subject(inputs)
});